import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { API_URL } from '../../../utils/constant';
import Modal from '../../../components/modal';
import TableDisplay from './table_display';
import { Eye } from 'lucide-react';
import { customTableStyles } from '../../../utils/tableStylings';

const ImportHistoryPage = () => {
  const [importFiles, setImportFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [heading, setHeading] = useState('');
  const [importData, setImportData] = useState({});
  const [importCompleted, setImportCompleted] = useState(null);
  const [activeTab, setActiveTab] = useState('products');

  const company = JSON.parse(localStorage.getItem('company'));

  const fetchImportFiles = async () => {
    try {
      const response = await fetch(`${API_URL}/import/list`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ company_id: company?.company?.id }),
      });
      const data = await response.json();
      setImportFiles(data.files || []);
    } catch (error) {
      console.error('Fetch import files failed', error);
    } finally {
      setLoading(false);
    }
  };

  const handleView = async (fileName) => {
    try {
      const res = await fetch(`${API_URL}/import/file?file=${fileName}`);
      const data = await res.json();
      setImportData(data);
      setHeading(new Date(data.imported_at).toLocaleString());
      setImportCompleted(data.import_completed);
      setActiveTab('products');
      setShow(true);
    } catch (err) {
      console.error('View file failed', err);
    }
  };

  const columns = [
    {
      name: '#',
      selector: (_, index) => index + 1,
      width: '60px',
    },
    {
      name: 'File Name',
      selector: row => row.file,
      sortable: true,
    },
    {
      name: 'Created At',
      selector: row => new Date(row.imported_at).toLocaleString(),
      sortable: true,
    },
    {
      name: 'Status',
      cell: row =>
        row.import_completed ? (
          <span className="badge bg-success">Completed</span>
        ) : (
          <span className="badge bg-danger">Pending</span>
        ),
      center: true,
    },
    {
      name: 'Action',
      cell: row => (
        <button className="btn btn-sm btn-primary" onClick={() => handleView(row.file)}>
          <Eye/>
        </button>
      ),
    },
  ];

  useEffect(() => {
    fetchImportFiles();
  }, []);

  return (
    <>
      <div className="row mt-4">
        <h4>Import History</h4>
        <div className='card'>
            <div className='card-body'>
                <DataTable
                    columns={columns}
                    data={importFiles}
                    progressPending={loading}
                    pagination
                    highlightOnHover
                    striped
                    responsive
                    customStyles={customTableStyles}
                    />
            </div>
        </div>
      </div>

      <Modal show={show} onClose={() => setShow(false)} heading={heading}>
        {/* Tabs */}
        <div className="mb-3">
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'products' ? 'active' : ''}`}
                onClick={() => setActiveTab('products')}
              >
                Products
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'suppliers' ? 'active' : ''}`}
                onClick={() => setActiveTab('suppliers')}
              >
                Suppliers
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'stock' ? 'active' : ''}`}
                onClick={() => setActiveTab('stock')}
              >
                Stock
              </button>
            </li>
          </ul>
        </div>

        {/* Tab Content */}
        <div
          className={`tab-content mt-3 p-3 rounded ${
            importCompleted === false
              ? 'bg-danger bg-opacity-50'
              : importCompleted === true
              ? 'bg-success bg-opacity-50'
              : ''
          }`}
        >
          {activeTab === 'products' && (
            <TableDisplay title="Products" data={importData.products || []} />
          )}
          {activeTab === 'suppliers' && (
            <TableDisplay title="Suppliers" data={importData.suppliers || []} />
          )}
          {activeTab === 'stock' && (
            <TableDisplay title="Stock" data={importData.stock || []} />
          )}
        </div>
      </Modal>
    </>
  );
};

export default ImportHistoryPage;
